import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';
import { SummaryRecurrentListModel, SummaryRecurrentModel } from '../../models/summary-recurrent.model';
import { RecurrentService } from '../../services/recurrent.service';
import {
  LoadRecurrents,
  LoadRecurrentsFailure,
  LoadRecurrentsSuccess,
  RecurrentActionTypes
} from '../actions/recurrent.actions';

@Injectable()
export class RecurrentEffects {
  constructor(
    private actions$: Actions,
    private service: RecurrentService
  ) { }

  
  loadRecurrents$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(RecurrentActionTypes.LoadRecurrents),
    switchMap((action: LoadRecurrents) =>
      this.service.getSummaryList(action.payload.filter).pipe(
        map((res: PaginableResponseModel<SummaryRecurrentModel> & { summary: SummaryRecurrentListModel }) => {
          if (!res || !res.isSuccess) {
            return new LoadRecurrentsFailure({ error: 'No se pudo cargar la lista de recurrentes' });
          }
          return new LoadRecurrentsSuccess({
            items: res.values,
            total: res.total,
            summary: res.summary
          });
        }),
        catchError(error => of(new LoadRecurrentsFailure({ error })))
      )
    )
  ));
}
